import { TTRouteConfig } from "@tt-app/models";
import { ROUTES } from "@tt-app/constants";

const { EXERCISE } = ROUTES;

export const exerciseRoutes: TTRouteConfig[] = [
  {
    name: EXERCISE.CHAT.NAME,
    path: EXERCISE.CHAT.PATH,
    type: "exercise",
    accessLevel: "authenticated",
    component: () =>
      import(/*webpackChunkName: "tt-core" */ "@tt-app/views/exercise/ExerciseConversation.vue")
  },
  {
    name: EXERCISE.DEMO.NAME,
    path: EXERCISE.DEMO.PATH,
    type: "exercise",
    accessLevel: "authenticated",
    component: () =>
      import(/*webpackChunkName: "tt-core" */ "@tt-app/views/exercise/ExerciseDemoConversation.vue")
  },
  {
    name: EXERCISE.DICTATION.NAME,
    path: EXERCISE.DICTATION.PATH,
    type: "exercise",
    accessLevel: "authenticated",
    component: () =>
      import(/*webpackChunkName: "tt-core" */ "@tt-app/views/exercise/ExerciseDictation.vue")
  },
  {
    name: EXERCISE.DRILL_LISTENING.NAME,
    path: EXERCISE.DRILL_LISTENING.PATH,
    type: "exercise",
    accessLevel: "authenticated",
    component: () =>
      import(/*webpackChunkName: "tt-core" */ "@tt-app/views/exercise/ExerciseDrill.vue")
  },
  {
    name: EXERCISE.DRILL_PRONUNCIATION.NAME,
    path: EXERCISE.DRILL_PRONUNCIATION.PATH,
    type: "exercise",
    accessLevel: "authenticated",
    component: () =>
      import(/*webpackChunkName: "tt-core" */ "@tt-app/views/exercise/ExerciseDrill.vue")
  },
  {
    name: EXERCISE.DRILL_VOCABULARY.NAME,
    path: EXERCISE.DRILL_VOCABULARY.PATH,
    type: "exercise",
    accessLevel: "authenticated",
    component: () =>
      import(/*webpackChunkName: "tt-core" */ "@tt-app/views/exercise/ExerciseDrill.vue")
  },
  {
    name: EXERCISE.PICTURE_MATCH.NAME,
    path: EXERCISE.PICTURE_MATCH.PATH,
    type: "exercise",
    accessLevel: "authenticated",
    component: () =>
      import(/*webpackChunkName: "tt-core" */ "@tt-app/views/exercise/PictureMatch.vue")
  },
  {
    name: EXERCISE.QUIZ_LISTENING.NAME,
    path: EXERCISE.QUIZ_LISTENING.PATH,
    type: "exercise",
    accessLevel: "authenticated",
    component: () =>
      import(/*webpackChunkName: "tt-core" */ "@tt-app/views/exercise/QuizListening.vue")
  },
  {
    name: EXERCISE.DRILL_TYPING.NAME,
    path: EXERCISE.DRILL_TYPING.PATH,
    type: "exercise",
    accessLevel: "authenticated",
    component: () =>
      import(/*webpackChunkName: "tt-core" */ "@tt-app/views/exercise/DrillTyping.vue")
  },
  {
    name: EXERCISE.SINGLE_SENTENCE_READING.NAME,
    path: EXERCISE.SINGLE_SENTENCE_READING.PATH,
    type: "exercise",
    accessLevel: "authenticated",
    component: () =>
      import(/*webpackChunkName: "tt-core" */ "@tt-app/views/exercise/SingleSentenceReading.vue")
  },
  {
    name: EXERCISE.QUIZ_TRANSLATION.NAME,
    path: EXERCISE.QUIZ_TRANSLATION.PATH,
    type: "exercise",
    accessLevel: "authenticated",
    component: () =>
      import(/* webpackChunkName: "tt-core" */ "@tt-app/views/exercise/QuizTranslation.vue")
  },
  {
    name: EXERCISE.DRILL_TRANSLATION.NAME,
    path: EXERCISE.DRILL_TRANSLATION.PATH,
    type: "exercise",
    accessLevel: "authenticated",
    component: () =>
      import(/* webpackChunkName: "tt-core" */ "@tt-app/views/exercise/DrillTranslation.vue")
  },
  {
    name: EXERCISE.EXERCISE_ROOT.NAME,
    path: EXERCISE.EXERCISE_ROOT.PATH,
    type: "exercise",
    accessLevel: "authenticated",
    component: () =>
      import(/* webpackChunkName: "tt-core" */ "@tt-app/views/exercise/ExerciseView.vue")
  }
];
